export var ERROR_TYPES = {
  FIELD_REQUIRED: 'FIELD_REQUIRED'
};